import React from "react";
import { useSubheader } from "../../../../_metronic/layout";
export const WeeklysLeaderboard = () => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Weekly Leaderboard");
  return <div></div>;
};
